import { render, staticRenderFns } from "./UtmSourceGroupsEditor.vue?vue&type=template&id=204e8165&scoped=true&"
import script from "./UtmSourceGroupsEditor.vue?vue&type=script&lang=js&"
export * from "./UtmSourceGroupsEditor.vue?vue&type=script&lang=js&"
import style0 from "./UtmSourceGroupsEditor.vue?vue&type=style&index=0&id=204e8165&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e8165",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCombobox,VIcon,VTextField})
